import React from 'react';
import './CPCard.css';

const CPCard = props => {
    console.log(props);
    return (
        <div className="container">
        <div className="card-container">
        <h1>{props.command}</h1>
        </div>
        <div className="card-container">
        <h1>{props.line}</h1>
        </div>
        </div>
    )
}

export default CPCard;